// extracted by mini-css-extract-plugin
export default {"wrapper":"HoraSelector_wrapper__b4Q2r"};